"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var SectionTitle_1 = __importDefault(require("@/Jetstream/SectionTitle"));
function JetFormSection(_a) {
    var onSubmit = _a.onSubmit, renderActions = _a.renderActions, title = _a.title, description = _a.description, children = _a.children;
    var hasActions = !!renderActions;
    return (react_1.default.createElement("div", { className: "md:grid md:grid-cols-3 md:gap-6" },
        react_1.default.createElement(SectionTitle_1.default, { title: title, description: description }),
        react_1.default.createElement("div", { className: "mt-5 md:mt-0 md:col-span-2" },
            react_1.default.createElement("form", { onSubmit: function (e) {
                    e.preventDefault();
                    onSubmit();
                } },
                react_1.default.createElement("div", { className: (0, classnames_1.default)('px-4 py-5 bg-white sm:p-6 shadow', hasActions
                        ? 'sm:rounded-tl-md sm:rounded-tr-md'
                        : 'sm:rounded-md') },
                    react_1.default.createElement("div", { className: "grid grid-cols-6 gap-6" }, children)),
                hasActions && (react_1.default.createElement("div", { className: "flex items-center justify-end px-4 py-3 bg-gray-50 text-right sm:px-6 shadow sm:rounded-bl-md sm:rounded-br-md" }, renderActions === null || renderActions === void 0 ? void 0 : renderActions()))))));
}
exports.default = JetFormSection;
